/* v23: one voice for every buy button, and a clear "select your size" nudge
   when the main Add to cart button is tapped before a size is picked. */
(function(){
if(window.__tcNudge)return;window.__tcNudge=1;
var d=document;
function $(s,r){return (r||d).querySelector(s)}
function $$(s,r){return [].slice.call((r||d).querySelectorAll(s))}
function low(n){return String(n||'').replace(/\s*\(.*?\)/g,'').trim().toLowerCase()}
function root(){return $('[data-tc-buy]')}
function bundleMulti(){var t=$('.tcb__tier[aria-checked=true]');return t&&Number(t.dataset.n)>1}
/* which choices are still missing: [] when ready */
function missing(r){
  var groups=$$('.tc-og',r);
  if(groups.length){
    return groups.filter(function(g){return !$('.tc-opt[aria-pressed=true]',g)})
      .map(function(g){var s=$('.tc-sl span',g);return {el:g,name:low(s&&s.textContent)||'option'}});
  }
  var w=$('.tc-sizes',r);if(!w)return [];
  if($('.tc-size[aria-pressed=true]',w))return [];
  var s=$('.tc-sl span',w);
  return [{el:w,name:low(s&&s.textContent)||'size'}];
}
function clear(){
  var m=$('#tc-msg');if(m&&m.hasAttribute('data-warn')){m.removeAttribute('data-warn');m.textContent=''}
}
function nudge(r,miss){
  var names=miss.map(function(x){return x.name});
  var txt='Select your '+(names.length>1?names.slice(0,-1).join(', ')+' and '+names[names.length-1]:names[0])+' to add to cart.';
  var m=$('#tc-msg');
  if(m){m.removeAttribute('data-warn');void m.offsetWidth;m.textContent=txt;m.setAttribute('data-warn','')}
  if(m&&m.scrollIntoView)m.scrollIntoView({behavior:'smooth',block:'nearest'});
}
/* runs before the page's other click handlers (window, capture phase) */
window.addEventListener('click',function(e){
  var t=e.target;if(!t||!t.closest)return;
  var r=root();if(!r||r.dataset.sizes!=='1')return;
  if(t.closest('.tc-size,.tc-opt')){setTimeout(function(){if(!missing(r).length)clear()},0);return}
  var c=t.closest('[data-tc-cta]');if(!c)return;
  if(c.id!=='tc-atc'){setTimeout(title,0);return}
  if(bundleMulti())return;
  var miss=missing(r);if(!miss.length)return;
  e.preventDefault();e.stopImmediatePropagation();
  nudge(r,miss);
},true);
/* popup titles: say what to do, not the button label */
function title(){
  var r=root();if(!r)return;
  var groups=$$('.tc-og .tc-sl span',r).map(function(s){return low(s.textContent)}).filter(Boolean);
  var t='Choose your '+(groups.length>1?groups.join(' & '):'size');
  ['#tc-pick','#tc-skp'].forEach(function(id){var p=$(id);if(!p)return;var s=$('.tc-bar span',p);if(s)s.textContent=t;p.setAttribute('aria-label',t)});
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',title);else title();
window.addEventListener('load',title);
})();
